// src/components/website/EventListView.js
// Card grid view of upcoming events for published practitioner websites.

import React from 'react';
import EventPublicCard from './EventPublicCard';

const EventListView = ({ events, practitionerSlug }) => {
  if (!events || events.length === 0) {
    return (
      <p style={{
        textAlign: 'center', color: '#9CA3AF', fontSize: 15,
        fontFamily: 'Montserrat, sans-serif', fontStyle: 'italic',
        padding: '40px 0',
      }}>
        No upcoming events — check back soon!
      </p>
    );
  }

  return (
    <>
      <style>{`
        .event-list-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 24px; }
        @media (max-width: 640px) { .event-list-grid { grid-template-columns: 1fr; } }
      `}</style>
      <div className="event-list-grid">
        {events.map(event => (
          <EventPublicCard key={event.id} event={event} practitionerSlug={practitionerSlug} />
        ))}
      </div>
    </>
  );
};

export default EventListView;
